import { Sparkles } from 'lucide-react';
import { cx } from './ui';

/**
 * Which model reads the instrument screens.
 *
 * Worth saying out loud rather than burying in a settings page. Somebody
 * deciding whether to trust a transcribed plate has a reasonable question —
 * "read by what?" — and naming the model answers it. It is also the honest
 * framing of what the app does: it does not read the numbers itself, it hands
 * the photograph to a model that does.
 *
 * Kept in one component so the name is changed in one place when the model
 * behind it changes, rather than going stale in three different footers.
 */
export const READER_MODEL = 'Claude Opus 5.5';

export default function PoweredBy({ className }: { className?: string }) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1.5 rounded-full border border-accent-500/30 bg-accent-500/10 px-2.5 py-1 text-xs text-accent-200',
        className,
      )}
      title={`Photographs and dictation are read by ${READER_MODEL}. Every value is checked by you before it is saved.`}
    >
      <Sparkles size={12} className="shrink-0" />
      Reads with {READER_MODEL}
    </span>
  );
}
